(function() {
    const popupLink = document.querySelector('[gr-popup]');

    if (popupLink) {
        document.addEventListener('click', function(event) {
            // If the clicked element doesn't have the right selector
            if (!event.target.matches('[gr-popup]')) return;

            event.preventDefault();
            const winHeight = 400;
            const winWidth = 600;

            const winTop = (window.innerHeight / 2) - (winHeight / 2);
            const winLeft = (window.innerWidth / 2) - (winWidth / 2);
            const url = event.target.getAttribute('href');

            window.open(url, '_blank', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
        }, false);
    }
}());
